import { React } from '@common/3rd';
import { Widget, checkAllRuntimeComponents } from '@component';
import { DeskFormProps, JLLayout } from '@jl-types';
import { Modeller } from '@model';
import { CheckableWidgetCheckResult } from '@my-types';
import { DeskContainer } from '../container/desk-container';

class DeskForm<P extends DeskFormProps, S, C> extends Widget<P, S, C> {
	protected initComponents(): C {
		return {} as C;
	}
	render() {
		return <DeskContainer model={this.getModel()} layout={this.getLayout()} />;
	}
	protected getModel() {
		return Modeller.asProxied(this.props.model);
	}
	protected getLayout(): JLLayout {
		return this.props.layout;
	}
	checkAllData(): Promise<CheckableWidgetCheckResult[] | void> {
		return checkAllRuntimeComponents();
	}
}

export { DeskForm };
